import { FC } from "react";
import { Content } from "@prismicio/client";
import { SliceComponentProps } from "@prismicio/react";
import { cn } from "@/lib/utils";
// import Image from "next/image";
import PromoBanner from "@/components/molecules/promo-banner/PromoBanner";
import { appLocales, Locales } from "@/lib/i18n";
import { __ } from "@/lib/i18n/functions";

export type NewsletterProps = SliceComponentProps<Content.NewsletterSlice> & {
  context?: { locale?: Locales };
};

const Newsletter: FC<NewsletterProps> = ({ slice, context }) => {
  const locale = context?.locale || appLocales.defaultLocale;
  const { title, description, button_label } = slice.primary;

  // Temporary hide section newsletter
  return null;

  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      className={cn("container my-7.5 flex items-stretch gap-5 px-4 sm:px-7.5")}
    >
      <PromoBanner
        promo={{ promoTitle: title || "", promoDescription: description, buttonText: button_label || "" }}
        success={{
          successTitle: __("Registration successful!", locale),
          successDescription: __("Your personal promo code has been sent to your email address", locale),
        }}
        locale={locale}
      />
      {/* {image.url && (
        <figure className="relative hidden flex-1 overflow-hidden rounded-2xl lg:block">
          <Image src={image.url} alt={image.alt || ""} fill className="absolute object-cover" />
        </figure>
      )} */}
    </section>
  );
};

export default Newsletter;
